import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icon-speaker.png'


const _withScopeId = n => (_pushScopeId("data-v-0fc69c83"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "integral-info"
}
const _hoisted_2 = { class: "integral-user" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "integral-score" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "当前积分", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "integral-speaker" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", null, "积分兑换商品时，可能会收取相应的积分运费")
], -1))
const _hoisted_8 = {
  key: 1,
  class: "good-list"
}

import { ref,onMounted,onActivated, createApp } from 'vue';
    import App from '../App.vue';

    import GoodList from '@/components/GoodList.vue'; // @ is an alias to /src
    import Navigate from "@/components/Navigate";
    import { useStore } from 'vuex';
    import { useRouter } from 'vue-router';
    import { getMemberInfoByOpenId, getMemberInfo, getProductList } from '@/server/api';
    import { getMemeberParam } from '@/server/interface';
    import { showDialog } from 'vant';
import productParam from '@/utils/vipRedirect'
    
export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

    const totalScore = ref(0);
    const $router = useRouter();
    const currentStateUrl = ref('');
    const currentState = ref('');
    const userInfo = ref({});
    let list = ref([]);
    const store = useStore();  // 该方法用于返回store 实例
    const headUrl = ref('');
    const authCode = ref('');
    const code = ref('');
    const tempState = ref('');
    const codeMsg = ref('');
    const hrefLink = ref('');
    const isErrorStatus = ref(false);
    const openId = ref('');

    onActivated(() => {
        
        // const $routerParams = new URL(window.location.href);
        authCode.value = $router.currentRoute.value.query?.authCode as string;
        const _state = $router.currentRoute.value.query?.state as string;
        currentState.value = _state as string;
        currentStateUrl.value = require(`../assets/${_state ? _state : 'clinique'}.jpg`);
        headUrl.value = require(`../assets/${_state ? _state : 'clinique'}_header.png`);
        code.value = $router.currentRoute.value.query?.code as string;
        codeMsg.value = $router.currentRoute.value.query?.msg as string;
        tempState.value = _state;
        hrefLink.value = window.location.href;
        store.dispatch("setCurrentState", currentState.value)   
        window.localStorage.setItem('currentState', currentState.value)
        // if($router.currentRoute.value.query?.openId) {
        //     openId.value = $router.currentRoute.value.query?.openId as string;
        //     window.localStorage.setItem('openId',  openId.value)
        //     store.dispatch("setOpenId",  openId.value)   
        // }
        openId.value = $router.currentRoute.value.query?.openId as string;
        window.localStorage.setItem('hrefLink', window.location.href.split('?')[1])
        getHome();
    })

    const getHome = async() => {
        
        debugger
        let res = {};
        if(window.localStorage.getItem(currentState.value)) {
            const params = {
                openId: window.localStorage.getItem(currentState.value)?.replace(new RegExp('\n','g'), '')
            }
            res = await getMemberInfoByOpenId(params);
        }else {
            const params:getMemeberParam = {
                authCode: $router.currentRoute.value.query?.authCode as string
            }
            res = await getMemberInfo(params);
        }
        
        if(!res.errorCode) {
             if(!res.data.avatar || res.data.avatar === "null") {
                window.localStorage.clear()
                window.location.href = productParam(currentState.value);
                return
            }
            isErrorStatus.value = false;
            userInfo.value = res.data;
            totalScore.value = res.data.totalPoint;
            headUrl.value = res.data.avatar && res.data.avatar != "null" ? res.data.avatar : require(`../assets/${currentState.value}_header.png`);
            store.dispatch("setTotalPoint", res.data.totalPoint)
            store.dispatch("setToken", res.data.accessToken)
            store.dispatch("setOpenId", res.data.openId) 
            window.localStorage.setItem('openId', res.data.openId)
      

            window.localStorage.setItem('userInfo',JSON.stringify(userInfo.value))
            openId.value = res.data.openId;
            store.dispatch("setCurrentState", currentState.value)   
            window.localStorage.setItem('currentState', currentState.value)
            console.log('currentState.value==>',currentState.value)
            console.log('res.data.openId==>',res.data.openId)
            window.localStorage.setItem(currentState.value, res.data.openId)
            window.localStorage.setItem(`accessToken${currentState.value}`,res.data.accessToken)
            getList();
        }else {
            isErrorStatus.value = true;
            showDialog({
                title: '提示',
                message: `您暂时还不是${currentState.value === 'origins' ? '悦木之源' : '倩碧'}品牌会员，请先返回唯品会${currentState.value === 'origins' ? '悦木之源' : '倩碧'}品牌会员页，加入会员尊享更多会员权益`,
                className: 'home-btn'
            }).then(() => {
                // on close
                isErrorStatus.value = false;
            });
        }
    }

    const getList = async() => {
        const params = !userInfo.value.customLevel || userInfo.value.customLevel == 'null' ? {} : {
            customLevel: userInfo.value.customLevel
        }
        const { data } = await getProductList(params);
        list.value = data;

        console.log(data)
    }

    const loadListInfo = (temp : any) => {
        if(temp) {
            getList()
        }
    }

    const poster = () => {
        window.location.href = `https://m.kuaidi100.com/app/query/?nu=YT3750479611143&coname=clinique`
    }

    // 获取store中的值
    // const setInfo = async () => {
    //     console.log(store.state.token)

    //     const params = {
    //         id:'1'
    //     }

    //     await getProductList(params).then((res: any) => {
    //         console.log(res);
    //     });
    // }

    const scoreOrder = () => {
        if (isErrorStatus.value) return;
        $router.push({
            name: "orderList",
        })
    }

    const pointsDetails = () => {
        if (isErrorStatus.value) return;
        $router.push({
            path: "/pointsDetails",
            query: {
                totalScore: userInfo.value?.totalPoint
            }
        })
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['home', currentState.value === 'origins' ? 'origins' : '', isErrorStatus.value ? 'home-error' : ''])
  }, [
    (openId.value || authCode.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: headUrl.value,
              alt: "",
              class: "custom-header"
            }, null, 8, _hoisted_3),
            _createElementVNode("p", null, [
              _createElementVNode("span", null, "Hi，尊敬的" + _toDisplayString(currentState.value === 'origins'? '悦木之源ORIGINS' : '倩碧CLINIQE') + "会员", 1),
              _createElementVNode("span", null, _toDisplayString(userInfo.value.nickName && userInfo.value.nickName != 'null' ? userInfo.value.nickName : currentState.value === 'origins'? 'ORIGINS_VIP' : 'CLINIQE_VIP'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("p", null, _toDisplayString(userInfo.value.totalPoint ? userInfo.value.totalPoint : 0), 1),
            _createElementVNode("p", null, [
              _createElementVNode("span", { onClick: pointsDetails }, "积分明细"),
              _hoisted_6,
              _createElementVNode("span", { onClick: scoreOrder }, "积分订单")
            ])
          ]),
          _hoisted_7
        ]))
      : _createCommentVNode("", true),
    ((authCode.value || openId.value) && !isErrorStatus.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(GoodList, {
            totalScore: totalScore.value,
            customLevel: userInfo.value.customLevel,
            list: _unref(list),
            onLoadListInfo: loadListInfo
          }, null, 8, ["totalScore", "customLevel", "list"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})